var version = 'v1';
var encryptionKey = 'BOe1W38E5e2ONozPwBsQNo0cbrmwpXEBtx17W7EzZxpEC6pF';
var sjcl = require('sjcl');

function versionedKey(key) {
	return version + '.' + key;
}

function encrypt(string) {
	if (string) {
		try {
			return sjcl.json.encrypt(encryptionKey, string);
		} catch (e) {
			console.error(e);
		}
	}
	return null;
}

function decrypt(string) {
	if (string) {
		try {
			return sjcl.json.decrypt(encryptionKey, string);
		} catch (e) {
			console.error(e);
		}
	}
	return null;
}

function _get(type, storage, key) {
	return _getOrFail(type, storage, key, false);
}

function _getOrFail(type, storage, key, fail) {
	if (fail && !storage) {
		throw new Error(type + ' ist nicht verfügbar');
	}
	if (storage) {
		var encrypted = storage.getItem(versionedKey(key));
		if (encrypted) {
			return JSON.parse(decrypt(encrypted));
		}
	} else {
		console.warn(type + ' ist nicht verfügbar');
	}
	return null;
}

function _set(type, storage, key, value) {
	_setOrFail(type, storage, key, value, false);
}

function _setOrFail(type, storage, key, value, fail) {
	if (fail && !storage) {
		throw new Error(type + ' ist nicht verfügbar');
	}
	if (storage) {
		storage.setItem(versionedKey(key), encrypt(JSON.stringify(value)));
	} else {
		console.warn(type + ' ist nicht verfügbar');
	}
}

function _remove(type, storage, key) {
	_removeOrFail(type, storage, key, false);
}

function _removeOrFail(type, storage, key, fail) {
	if (fail && !storage) {
		throw new Error(type + ' ist nicht verfügbar');
	}
	if (storage) {
		storage.removeItem(versionedKey(key));
	} else {
		console.warn(type + ' ist nicht verfügbar');
	}
}

var Storage = {
	Local: {
		getItem: function (key) {
			return _get('localStorage', window.localStorage, key);
		},
		getItemOrFail: function (key) {
			return _getOrFail('localStorage', window.localStorage, key);
		},
		setItem: function (key, value) {
			_set('localeStorage', window.localStorage, key, value);
		},
		setItemOrFail: function (key, value) {
			_setOrFail('localStorage', window.localStorage, key, value);
		},
		removeItem: function (key) {
			_remove('localStorage', window.localStorage, key);
		},
		removeItemOrFail: function (key) {
			_removeOrFail('localStorage', window.localStorage, key);
		}
	},
	Session: {
		getItem: function (key) {
			return _get('sessionStorage', window.sessionStorage, key);
		},
		getItemOrFail: function (key) {
			return _getOrFail('sessionStorage', window.sessionStorage, key);
		},
		setItem: function (key, value) {
			_set('sessionStorage', window.sessionStorage, key, value);
		},
		setItemOrFail: function (key, value) {
			_setOrFail('sessionStorage', window.sessionStorage, key, value);
		},
		removeItem: function (key) {
			_remove('sessionStorage', window.sessionStorage, key);
		},
		removeItemOrFail: function (key) {
			_removeOrFail('sessionStorage', window.sessionStorage, key);
		}
	},
	getPreferred: function () {
		if (window.zweConfig && window.zweConfig.ui_filter_use_localstorage === true) {
			return Storage.Local;
		} else {
			return Storage.Session;
		}
	}
};

module.exports = Storage;
